import { render, staticRenderFns } from "./customerTabs.vue?vue&type=template&id=8e031894&"
import script from "./customerTabs.vue?vue&type=script&lang=js&"
export * from "./customerTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports